/* eslint-disable import/prefer-default-export */
export const HelpVTour = () => {
  const stepsDashAlumno = [
    {
      target: '#option-5',
      header: {
        title: 'Solicitudes',
      },
      content: 'Hola, aqui podras ver las solicitudes autorizadas o rechazadas asi como el detalle de aportaciones.',
    },
    {
      target: '#option-2',
      header: {
        title: 'Cuenta y Configuraciones',
      },
      content: 'Puedes configurar tus datos de facturación, Subir documentación, preferencias etc.',
    },
    {
      target: '#option-3',
      header: {
        title: 'Especialidades, cuatrimestres y cursos contratados',
      },
      content: 'Podrás ver tu avance dentro del Campus Virtual y tus especialidades así como tus evaluaciones.',
    },
    {
      target: '#option-4',
      header: {
        title: 'Mi perfil',
      },
      content: 'En esta sección, puedes llenar toda tu información personal, para futuras referencias.',
    },
  ]
  const stepsPublicUpload = [
    {
      target: '#btn-df',
      header: {
        title: 'Datos de Facturación',
      },
      content: 'Si requieres facturar tu inscripción, primero configura esta sección para poder solicitar.',
      params: {
        placement: 'top',
      },
    },
    {
      target: '#btn-tran',
      header: {
        title: 'Transacciones',
      },
      content: 'Lista de todos los comprobantes de pagos enviados a Indetec.',
    },
    {
      target: '#btn-sp',
      header: {
        title: 'Subir Comprobante',
      },
      content: 'Podrás subir varias veces si lo necesitas los comprobantes de pago que se te pidan.',
    },
    {
      target: '#btn-prefac',
      header: {
        title: 'Pre-Factura',
      },
      content: 'Si requieres factura antes de proceder al pago, puedes solicitarla aqui.',
    },
    {
      target: '#cmp-solicitud',
      header: {
        title: 'Número de Solicitud',
      },
      content: 'Este número, es importante para el seguimiento de tu solicitud de inscripción',
    },
    {
      target: '#cmp-referencia',
      header: {
        title: 'Referencia y más',
      },
      content: 'Toda la información necesaria para poder pagar tu solicitud como la fecha limite, transacción que valida la solicitud, y la referencia a usar.',
    },
    {
      target: '#cmp-aportacion',
      header: {
        title: 'Aportación',
      },
      content: 'Total de la aportación que se le solicita.',
    },
  ]

  return {
    stepsDashAlumno,
    stepsPublicUpload,
  }
}
